export default "__VITE_ASSET__CPaZyHA$__"